(() => {
  const drawer = document.querySelector('[data-menu-drawer]');
  const trigger = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const overlay = document.querySelector('[data-menu-overlay]');
  if (!drawer || !trigger || !overlay) return;
  let lastFocus;
  const setOpen = (open) => {
    document.body.classList.toggle('menu-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    trigger.setAttribute('aria-expanded', String(open));
    overlay.hidden = !open;
    if (open) {
      lastFocus = document.activeElement;
      window.requestAnimationFrame(() => drawer.querySelector('a, button, input')?.focus());
    } else if (lastFocus) lastFocus.focus();
  };
  trigger.addEventListener('click', () => setOpen(true));
  close?.addEventListener('click', () => setOpen(false));
  overlay.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && document.body.classList.contains('menu-open')) setOpen(false); });
})();

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loader = document.querySelector('.site-loader');
  const completeLoad = () => {
    document.body.classList.remove('is-loading');
    document.body.classList.add('is-ready');
    window.setTimeout(() => loader?.remove(), reduceMotion ? 0 : 650);
  };
  if (document.readyState === 'complete') completeLoad();
  else window.addEventListener('load', completeLoad, { once: true });

  if (reduceMotion || !('IntersectionObserver' in window)) return;
  const revealTargets = document.querySelectorAll([
    '.section-heading', '.product-card', '.gear-categories a', '.capability-grid article',
    '.edition-card', '.docs-panel', '.contact-intro', '.contact-panel', '.portal-intro',
    '.portal-panel', '.cart-line', '.cart-summary', '.product__media', '.product__info',
    '.forge-overview > *', '.forge-system > *', '.lab-manifesto > *', '.protocol > *'
  ].join(','));
  revealTargets.forEach((target, index) => {
    target.classList.add('scroll-reveal');
    target.style.setProperty('--reveal-delay', `${Math.min(index % 5, 4) * 70}ms`);
  });
  const observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      instance.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
  revealTargets.forEach((target) => observer.observe(target));
})();

(() => {
  const form = document.querySelector('[data-product-form]');
  const select = form?.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-variant-price]');
  const button = form?.querySelector('[data-add-to-cart]');
  if (!form || !select || !price || !button) return;
  const updateVariant = () => {
    const option = select.options[select.selectedIndex];
    const available = option.dataset.available === 'true';
    price.textContent = option.dataset.price;
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  };
  select.addEventListener('change', updateVariant);
  updateVariant();
})();
